<template>
  <div class="sm_star">
    <!-- header -->
    <!-- <div class="sm_header">
			<h1>Samsung STAR</h1>
			<button class="menu_btn"><span>mobile menu</span></button>
		</div> -->
    <!-- <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      ref="top_app_bar"
    >
    </TopAppBar> -->
    <!-- //header -->

    <!-- content -->
    <div class="sm_content" v-if="popupData">
      <div class="header-div">
        <div class="head-text t-center">
          <div class="text">{{ $t("1890") }}</div>
        </div>
      </div>
      <div class="sm_visual" @click="redirectOnPage(popupData[currentPopup])">
        <img
          class="popup-img"
          :src="popupData[currentPopup].image.resourceUri"
          alt=""
        />
      </div>
      <div
        class="sm_wrap popup_checkbox"
        v-if="popupData.length == currentPopup + 1"
      >
        <div class="sm_position">
          <div class="mdc-form-field">
            <div class="mdc-checkbox">
              <input
                type="checkbox"
                class="mdc-checkbox__native-control"
                id="checkbox-1"
                v-model="checkBox"
              />

              <div class="mdc-checkbox__background">
                <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                  <path
                    class="mdc-checkbox__checkmark-path"
                    fill="none"
                    d="M1.73,12.91 8.1,19.28 22.79,4.59"
                  />
                </svg>
                <div class="mdc-checkbox__mixedmark"></div>
              </div>

              <div class="mdc-checkbox__ripple"></div>
            </div>
            <label for="checkbox-1">{{ $t("S10041") }} </label>
          </div>
        </div>
      </div>
      <div class="mgt-7" style="padding: 0px 16px 5px 16px">
        <button
          @click.prevent="closePopup"
          class="mdc-button mdc-button--raised btn-red w-full btn-big custom-btn"
        >
          {{ $t("3065") }}
          <!-- 로그인  -->
        </button>
      </div>
    </div>
  </div>
  <!-- //content -->
  <!-- </div> -->
</template>

<script>
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import popupApi from "@/api/popupApi.js";
export default {
  name: "Main",
  data() {
    return {
      popupData: null,
      responseData: null,
      checkBox: false,
      popupDataLength: 0,
      currentPopup: 0,
    };
  },
  components: {
    TopAppBar,
  },

  mixins: [topAppBarMixin],

  mounted() {
    this.setTopAppBarClosePopup(this.$t("1890"));

    this.$showLoading();
    // get learn basic information
    popupApi
      .fetpopupDetail()
      .then((response) => {
        this.popupData = response.data.data;
        this.popupDataLength = this.popupData.length;
        // console.log("popupData=====================", this.popupData);
        this.$hideLoading();
      })
      .catch((err) => {
        this.responseData = err.response.data.meta;
        this.$error({ content: this.responseData.errMsg }).then(() => {});
      });
  },

  methods: {
    closePopup() {
      sessionStorage.setItem("popupRedirect1", "yes");
      if (this.currentPopup < this.popupDataLength - 1) {
        this.currentPopup++;
      } else {
        if (this.checkBox) {
          //save in local storage
          let popupTime = new Date().getTime();
          localStorage.setItem("popupTime", popupTime);
        }
        // sessionStorage.setItem("popupRedirect1", "yes");
        this.$router.push("/home");
      }
    },

    redirectOnPage(popupObject) {
      let popUpType = popupObject.linkType.toLowerCase();
      let redirectUrl = "";
      console.log("--------------------", popupObject);
      switch (popUpType) {
        case "home":
          redirectUrl = "/home";
          break;

        case "content":
          redirectUrl = "/learn?status=CONTENTS&category=1";
          break;

        case "elearning":
          redirectUrl = "/learn?status=LEARNING&category=15";
          break;

        case "course detail":
          redirectUrl = "/learn/15877585?status=CONTENTS&category=1";
          break;

        case "forum":
          redirectUrl = "/socialLearning/9999911260?bId=SNS";
          break;

        // case "epromoter":
        //   redirectUrl = "/ePromoter/9999911493?bId=E-PROMOTER";
        //   break;
        default:
          redirectUrl = "";
      }
      this.$router.push(redirectUrl);
    },
  },
};
</script>

<style scoped>
.header-div {
  background: #313d4b;
  height: 56px !important;
  width: 100%;
}
.header-div .head-text {
  height: 29px;
  font-size: 20px;
  padding-top: 18px;
  color: #fffefe;
}
.sm_visual {
  height: 450px;
  width: 100%;
  overflow: auto;
}
.sm_content {
  background: white;
}
.sm_star {
  background: rgba(0, 0, 0, 0.5);
  padding-top: 37.5px;
  padding-left: 2.5%;
  height: 100%;
  padding-right: 2.5%;
}

@media (max-width: 320px) {
  .sm_star {
    padding-bottom: 2.5%;
    height: initial !important;
  }
}

.sm_wrap.popup_checkbox {
  margin: 0px !important;
  background: white !important;
}
/* @media only screen and (max-width: 320px) {
  body {
    padding-bottom: 2.5%;
    height: initial !important;
  }
} */
/* .mdc-checkbox__background::before {
  background-color: initial;
}

.mdc-checkbox__native-control:enabled:checked
  ~ .mdc-checkbox__background::before {
  background-color: var(--mdc-theme-secondary, #546e7a);
  animation-name: example;
  animation-duration: 2s;
  animation-fill-mode: forwards;
} */
</style>